/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext } from 'react';
import { Content, Label1, Text } from './styles';

import { Col, Row } from "components/Grid";
import { NotesAccordion } from "components";
import { GlobalAuthContext } from 'store/context';

export default function BrokingSummary({ data }) {

  const { typeOfCover, client, obligorCoding, responseBy, internalContact, broker, idOperation } = data;
  const authContext = useContext(GlobalAuthContext);
  const isClient = authContext.enumProfile === 1 ? true : false;

  return (
    <Content>
      <Row>
        <Col sm={4} className="pl-sm-4">
          <Label1>Type Of Cover</Label1>
          <Text>{typeOfCover}</Text>

          <Label1>Client</Label1>
          <Text>{client}</Text>
        </Col>
        <Col sm={4} className="pl-sm-4">
          <Label1>Obligor Coding</Label1>
          <Text>{obligorCoding}</Text>

          <Label1>Internal Contact</Label1>
          <Text>{internalContact}</Text>
        </Col>
        <Col sm={4} className="pl-sm-4">
          <Label1>Response By</Label1>
          <Text>{responseBy}</Text>

          <Label1>Broker</Label1>
          <Text>{broker}</Text>
        </Col>
      </Row>
      <Row sm={12} md={12}>
        {!isClient && <NotesAccordion
          title="Notes"
          idOperation={idOperation}
        />}
      </Row>

    </Content>
  )
}